const radConfig = {
  allottement_status: false,
  currentUrl: "https://starneuberg.aikenist.com/",
  previousVisitUrl: "https://medapps.medallcorp.in",
  baseUrl: "https://starneuberg.aikenist.com/api/quickrad",
  baseUrlRadio: "https://starneuberg.aikenist.com/api/quickrad/radio",
  radTitle: "AIkenist Technology Pvt. Ltd.",
  viewerURL: "https://starneuberg.aikenist.com/aikenviewer/viewer/",
  viewer3DURL:"https://starneuberg.aikenist.com/3daikenviewer/viewer?StudyInstanceUIDs=",
  viewerPET:"https://starneuberg.aikenist.com/3daikenviewer/tmtv?StudyInstanceUIDs=",
  viewerSM:"https://starneuberg.aikenist.com/3daikenviewer/microscopy?StudyInstanceUIDs=",
  viewerSeg:"https://starneuberg.aikenist.com/3daikenviewer/segmentation?StudyInstanceUIDs=",
  viewerMultiple: "https://starneuberg.aikenist.com/3daikenviewer/viewer?",
  viewerMultiplePet: "https://starneuberg.aikenist.com/3daikenviewer/tmtv?",
  medDream:"https://starneuberg.aikenist.com/?study=",
  thumbnailURL: "https://starneuberg.aikenist.com/dicom-web/instances/",
  gifURL:
  "https://starneuberg.aikenist.com/api/quickrad/general/convert-to-gif?series_ins=",
  dicomWeb: "https://starneuberg.aikenist.com/dicom-web",
  weasisDicomWeb: "https://starneuberg.aikenist.com/dicom-web",
  studyList: "https://starneuberg.aikenist.com/dicom-web/studies",
  localViewer: "https://starneuberg.aikenist.com/aikenviewer/local",
  client: "starneuberg",
  paymentComplete: true,
  version: "v2.0",
  radiAntPath: "C:\\xampp\\htdocs\\python\\input_scan\\tmp"
};

// ******************************************

localStorage.setItem("client", radConfig.client);

if (
  localStorage.getItem("showTAT") == "" ||
  localStorage.getItem("showTAT") == null
) {
  localStorage.setItem("showTAT", "false");
}
if (
  localStorage.getItem("studyTracker") == "" ||
  localStorage.getItem("studyTracker") == null
) {
  localStorage.setItem("studyTracker", "false");
}

export default radConfig;
